import React from 'react';
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from '@sandtech-hub-monorepo/ui-kit';
import { PaymentsTab } from './PaymentsTab';

export const SettingsPage = () => {
  return (
    <div className="bg-background border border-heading rounded sm:p-8 p-4 flex flex-col gap-8 max-w-screen-2xl mx-auto m-6">
      <Tabs defaultValue="payments" className="flex flex-col gap-8">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-1">
            <h1 className="font-semibold text-[32px] leading-[42px] text-foreground">
              Account
            </h1>
          </div>
          <TabsList className="h-auto bg-transparent border-b border-muted rounded-none p-0 justify-start">
            <TabsTrigger
              value="payments"
              className="data-[state=active]:border-heading data-[state=active]:border-b-2 data-[state=active]:text-heading text-muted-foreground font-semibold rounded-none"
            >
              Payments
            </TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value="payments" className="mt-0">
          <PaymentsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};
